import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {Edit as EditIcon, Delete as DeleteReadingIcon} from '@material-ui/icons';
import {Grid, Button} from '@material-ui/core';
import {isEmpty} from 'lodash/lang';
import {withKluwellTableWrapper, KluwellTableCore, SortingManager, DeletionConfirmBox} from 'components/common';
import {formatDatetime, buildUserFullName} from 'utils/common';
import ReactDOM from 'react-dom';

const buildAdminReadingRecords = (readings) => {
  const sortedIds = readings.sortedIds || [];
  return isEmpty(sortedIds)
    ? []
    : sortedIds.map((readingId) => {
        const reading = readings[readingId];
        const {book = {}, readerSchool = {}} = reading;
        return {
          record: reading,
          id: readingId,
          reader: buildUserFullName(reading.reader),
          readerSchool: readerSchool.name,
          book: book.title,
          page: reading.page,
          dateCreated: formatDatetime(reading.dateCreated, false, 'dddd Do MMMM, YYYY'),
          comment: reading.comment,
          actions: '',
        };
      });
};

const buildAdminReadingSettings = () => ({
  reader: {
    fieldText: 'Student',
    formatData: (cell, row) => <Link to={`/users/${row.record.reader.id}`}>{cell}</Link>,
    sortable: true,
  },
  readerSchool: {
    fieldText: 'School',
    formatData: (cell, row) => <Link to={`/schools/${row.record.readerSchool.id}`}>{cell}</Link>,
    sortable: true,
  },
  book: {
    fieldText: 'Book',
    formatData: (cell, {record: {book = {}}}) => (isEmpty(book) ? '' : <Link to={`/books/${book.id}`}>{cell}</Link>),
  },
  page: {
    fieldText: 'Page',
  },
  dateCreated: {
    fieldText: 'Date',
    sortable: true,
  },
  comment: {
    fieldText: 'Comment',
  },
  actions: {
    fieldText: 'Actions',
    formatData: (cell, row, restProps) => (
      <Grid container alignItems="center" justify="center">
        <Grid item>
          <Button
            variant="contained"
            size="small"
            className="small-margin-around"
            onClick={() => restProps.openSendMessageModal(row.record)}
            style={{maxWidth: 80}}
          >
            Send Message
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            size="small"
            className="small-margin-around"
            onClick={() => restProps.showDeletionConfirmBox(row.record, true)}
            style={{maxWidth: 80}}
          >
            Delete Comment
          </Button>
        </Grid>
        <Grid item>
          <EditIcon className="cursor-pointer" onClick={() => restProps.showUpdateModal(row.record)} />
        </Grid>
        <Grid item>
          <DeleteReadingIcon
            className="cursor-pointer"
            onClick={() => restProps.showDeletionConfirmBox(row.record, false)}
          />
        </Grid>
      </Grid>
    ),
  },
});

class AdminReadingTableCore extends React.Component {
  static propTypes = {
    recordPages: PropTypes.object.isRequired,
    onSortableFieldClick: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      adminReadingToRemove: {},
      deleteComment: true,
    };
    this.showDeletionConfirmBox = this.showDeletionConfirmBox.bind(this);
    this.sortingManager = new SortingManager();
  }

  showDeletionConfirmBox(adminReading, deleteComment) {
    this.setState(
      {
        adminReadingToRemove: adminReading,
        deleteComment: deleteComment,
      },
      () => {
        ReactDOM.findDOMNode(this.deletionConfirmBoxRef)
          .querySelector('.btn-show-confirm')
          .click();
      },
    );
  }

  render() {
    const {recordPages, onSortableFieldClick, onDeleteActionClick, hiddenFields, ...restProps} = this.props;
    const {adminReadingToRemove, deleteComment} = this.state;
    const readings = recordPages[recordPages.currentPage] || {};
    const records = buildAdminReadingRecords(readings);
    const settings = buildAdminReadingSettings();
    return (
      <React.Fragment>
        <DeletionConfirmBox
          ref={(ref) => (this.deletionConfirmBoxRef = ref)}
          itemName={deleteComment ? 'comment of the reading' : 'reading'}
          deleteAction={() => onDeleteActionClick(adminReadingToRemove, deleteComment)}
          DeleteButton="span"
        />
        <KluwellTableCore
          {...{
            records,
            settings,
            sortingManager: this.sortingManager,
            onSortableFieldClick,
            showDeletionConfirmBox: this.showDeletionConfirmBox,
            hiddenFields,
            ...restProps,
          }}
        />
      </React.Fragment>
    );
  }
}

export default withKluwellTableWrapper(AdminReadingTableCore);
